/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RunEventBasedAppSessionMutationVariables = Types.Exact<{
  appSessionId: Types.Scalars["AppSessionId"]["input"];
  executeTrace: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  forceOverwriteCache: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type RunEventBasedAppSessionMutation = {
  readonly __typename: "Mutation";
  readonly runEventBasedAppSession: string;
};

export type UpdateDefaultAppSessionMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  savedViewId: Types.InputMaybe<Types.Scalars["SavedViewId"]["input"]>;
  overwriteCache: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type UpdateDefaultAppSessionMutation = {
  readonly __typename: "Mutation";
  readonly runLastPublishedVersionForHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
  };
};

export const RunEventBasedAppSessionDocument = /*#__PURE__*/ gql`
  mutation RunEventBasedAppSession(
    $appSessionId: AppSessionId!
    $executeTrace: Boolean
    $forceOverwriteCache: Boolean
  ) {
    runEventBasedAppSession(
      appSessionId: $appSessionId
      executeTrace: $executeTrace
      forceOverwriteCache: $forceOverwriteCache
    )
  }
`;
export type RunEventBasedAppSessionMutationFn = Apollo.MutationFunction<
  RunEventBasedAppSessionMutation,
  RunEventBasedAppSessionMutationVariables
>;

/**
 * __useRunEventBasedAppSessionMutation__
 *
 * To run a mutation, you first call `useRunEventBasedAppSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunEventBasedAppSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runEventBasedAppSessionMutation, { data, loading, error }] = useRunEventBasedAppSessionMutation({
 *   variables: {
 *      appSessionId: // value for 'appSessionId'
 *      executeTrace: // value for 'executeTrace'
 *      forceOverwriteCache: // value for 'forceOverwriteCache'
 *   },
 * });
 */
export function useRunEventBasedAppSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunEventBasedAppSessionMutation,
    RunEventBasedAppSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RunEventBasedAppSessionMutation,
    RunEventBasedAppSessionMutationVariables
  >(RunEventBasedAppSessionDocument, options);
}
export type RunEventBasedAppSessionMutationHookResult = ReturnType<
  typeof useRunEventBasedAppSessionMutation
>;
export type RunEventBasedAppSessionMutationResult =
  Apollo.MutationResult<RunEventBasedAppSessionMutation>;
export type RunEventBasedAppSessionMutationOptions = Apollo.BaseMutationOptions<
  RunEventBasedAppSessionMutation,
  RunEventBasedAppSessionMutationVariables
>;
export const UpdateDefaultAppSessionDocument = /*#__PURE__*/ gql`
  mutation UpdateDefaultAppSession(
    $hexId: HexId!
    $savedViewId: SavedViewId
    $overwriteCache: Boolean
  ) {
    runLastPublishedVersionForHex(
      hexId: $hexId
      savedViewId: $savedViewId
      overwriteCache: $overwriteCache
    ) {
      id
    }
  }
`;
export type UpdateDefaultAppSessionMutationFn = Apollo.MutationFunction<
  UpdateDefaultAppSessionMutation,
  UpdateDefaultAppSessionMutationVariables
>;

/**
 * __useUpdateDefaultAppSessionMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultAppSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultAppSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultAppSessionMutation, { data, loading, error }] = useUpdateDefaultAppSessionMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      savedViewId: // value for 'savedViewId'
 *      overwriteCache: // value for 'overwriteCache'
 *   },
 * });
 */
export function useUpdateDefaultAppSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDefaultAppSessionMutation,
    UpdateDefaultAppSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDefaultAppSessionMutation,
    UpdateDefaultAppSessionMutationVariables
  >(UpdateDefaultAppSessionDocument, options);
}
export type UpdateDefaultAppSessionMutationHookResult = ReturnType<
  typeof useUpdateDefaultAppSessionMutation
>;
export type UpdateDefaultAppSessionMutationResult =
  Apollo.MutationResult<UpdateDefaultAppSessionMutation>;
export type UpdateDefaultAppSessionMutationOptions = Apollo.BaseMutationOptions<
  UpdateDefaultAppSessionMutation,
  UpdateDefaultAppSessionMutationVariables
>;
